import React, { useEffect, useState } from "react";
import { api, friendlyError } from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { ImpactBadge } from "../lib/ui";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["Open", "In progress", "Waiting", "Completed", "Verified", "Closed"];
const STATUS_COLOR = {
  "Open": "#2563EB", "In progress": "#D97706", "Waiting": "#64748B",
  "Completed": "#16A34A", "Verified": "#0891B2", "Closed": "#334155",
};
const COLS = ["Open", "In progress", "Waiting", "Completed"];

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", department: "Regulatory", priority: "Medio", due_date: "" });

  const load = () => api.get("/tasks").then((r) => setTasks(r.data)).catch(() => toast.error("Impossibile caricare le attività"));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/tasks", form); toast.success("Attività creata"); setShow(false); load(); }
    catch (e) { toast.error(friendlyError(e)); }
  };
  const changeStatus = async (t, status) => {
    try { await api.put(`/tasks/${t.id}`, { status }); load(); } catch (e) { toast.error(friendlyError(e)); }
  };

  const isOverdue = (t) => t.due_date && new Date(t.due_date) < new Date() && !["Closed", "Verified", "Completed"].includes(t.status);

  return (
    <div className="ri-fade-in">
      <PageHeader overline="Action Hub" title="Le mie attività"
        subtitle="Workflow operativo: assegnazioni, scadenze, evidenze e chiusura. Signal → Assessment → Action → Review → Closure."
        actions={<button onClick={() => setShow(true)} data-testid="task-add-btn" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-blue-700 text-white text-sm hover:bg-blue-800"><Plus size={15} /> Nuova attività</button>} />

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        {COLS.map((col) => (
          <div key={col} className="rounded-xl bg-slate-100/60 border border-slate-200 p-3" data-testid={`task-col-${col}`}>
            <div className="flex items-center justify-between mb-3 px-1">
              <span className="text-sm font-semibold" style={{ color: STATUS_COLOR[col] }}>{col}</span>
              <span className="text-xs text-slate-400">{tasks.filter((t) => t.status === col).length}</span>
            </div>
            <div className="space-y-2">
              {tasks.filter((t) => t.status === col).map((t) => (
                <div key={t.id} data-testid={`task-card-${t.id}`} className="rounded-lg bg-white border border-slate-200 p-3 shadow-sm">
                  <div className="flex items-start justify-between gap-2 mb-1.5">
                    <ImpactBadge level={t.priority} small />
                    {isOverdue(t) && <span className="text-[0.6rem] font-mono px-1.5 py-0.5 rounded bg-red-100 text-red-700">SCADUTA</span>}
                  </div>
                  <div className="text-sm font-medium leading-snug">{t.title}</div>
                  {t.description && <div className="text-xs text-slate-500 mt-1 line-clamp-2">{t.description}</div>}
                  <div className="flex items-center justify-between mt-2 text-[0.65rem] text-slate-400 font-mono">
                    <span>{t.department}</span><span>{(t.due_date || "").slice(0, 10)}</span>
                  </div>
                  <select value={t.status} onChange={(e) => changeStatus(t, e.target.value)} data-testid={`task-status-${t.id}`}
                    className="w-full mt-2 text-xs px-2 py-1 rounded-md border border-slate-200 bg-slate-50">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {show && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(15,23,42,0.6)" }}>
          <div className="bg-white rounded-xl w-full max-w-md p-6">
            <div className="flex items-center justify-between mb-4"><h3 className="font-head font-semibold text-lg">Nuova attività</h3><button onClick={() => setShow(false)}><X size={18} /></button></div>
            <div className="space-y-3">
              <input placeholder="Titolo" data-testid="task-title-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm" />
              <textarea placeholder="Descrizione" rows={2} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm" />
              <div className="grid grid-cols-2 gap-3">
                <input placeholder="Reparto" value={form.department} onChange={(e) => setForm({ ...form, department: e.target.value })} className="px-3 py-2 rounded-lg border border-slate-200 text-sm" />
                <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className="px-3 py-2 rounded-lg border border-slate-200 text-sm bg-white">
                  {["Critico", "Alto", "Medio", "Basso", "Informativo"].map((p) => <option key={p}>{p}</option>)}
                </select>
              </div>
              <input type="date" value={form.due_date?.slice(0, 10) || ""} onChange={(e) => setForm({ ...form, due_date: e.target.value })} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm" />
              <button onClick={create} data-testid="task-save-btn" className="w-full py-2.5 rounded-lg bg-blue-700 text-white text-sm font-medium hover:bg-blue-800">Salva attività</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
